exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".pagination[data-v-019deefd]{margin-top:20px;text-align:right}.question-tag[data-v-019deefd]{margin-right:4px;margin-bottom:4px}.text-muted[data-v-019deefd]{color:#909399}", "", {"version":3,"sources":["/workspace/src/views/order-review-target-management/pages/KeyinExceptionFeedback.vue"],"names":[],"mappings":"AACA,6BAA6B,gBAAgB,gBAAgB,CAC5D,AACD,+BAA+B,iBAAiB,iBAAiB,CAChE,AACD,6BAA6B,aAAa,CACzC","file":"KeyinExceptionFeedback.vue","sourcesContent":["\n.pagination[data-v-019deefd]{margin-top:20px;text-align:right\n}\n.question-tag[data-v-019deefd]{margin-right:4px;margin-bottom:4px\n}\n.text-muted[data-v-019deefd]{color:#909399\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-019deefd","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/order-review-target-management/pages/KeyinExceptionFeedback.vue
// module id = 4673
// module chunks = 305